import * as FinalFormAction from './actions/form_final.actions';
import { FinalForm } from '../models/final_form.model';

export type Action = FinalFormAction.All;

const defaultState = {
    formulario : '',
    tipo_solicitud: '',
    tipo_recepcion: '',
    propiedad : '',
    propietarios: '',
    representantes: '',
    arquitectos: '',
    empresas: '',
    constructores: '',
    constructora: '',
    independiente: '',
    informe: '',
    declaracion: '',
    permiso_notariado: '',
    cip: '',
    proyecto: '',
    plazo: '',
    antecedentes: '',
    caracteristica_proyecto: '',
    datos_proyecto: '',
    antecedentes_edif: '',
    anteproy_condominio: '',
    autorizaciones: '',
    clasificacion: '',
    condiciones: '',
    disposicion: '',
    disposiciones_esp: '',
    normas_urbanisticas: '',
    recepcion: '',
    recepcion_parcial: '',
    registro_bienes: '',
    superficie: '',
    superficie_anteproyecto: '',
    unidades: '',
    uso_publico: '',
    ampliacion: '',
    archivos: '',
    Permisos: '',
    permisos_recep: '',
    permisos_recepciones: '',
    idusuario_mongo: ''
}

const newState = (state, newData) => {
    return Object.assign({}, state, newData);
}

export function finalFormReducer(state: FinalForm = defaultState, action){
    switch(action.type){
        case FinalFormAction.CREATE_FORM:
            return newState(state, {
                ...action.newFormValues
            });
        default:
            return state;
    }
}